import React, { useContext } from 'react';
import ProductImage from '../../../common/ProductImage';
import DeliveryWindow from './DeliveryWindow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift } from '@fortawesome/free-solid-svg-icons';
import UserContext from '../../../user/UserContext';

export default function Product(props) {
    const { userDetails } = useContext(UserContext);
    const product = props.product;
    const reward = props.reward;
    const qtyOrdered = props.product.deliveryWindows
        .map(dw => (!!dw.quantity ? dw.quantity : 0))
        .reduce((a, b) => a + b, 0);
    const minDisabled =
        !userDetails.telesales && !!props.product.minQty && qtyOrdered <= props.product.minQty;
    const maxDisabled =
        !userDetails.telesales && !!props.product.maxQty && qtyOrdered >= props.product.maxQty;

    const numberToPrice = numberField => {
        return numberField !== null ? '£' + numberField.toFixed(2) : '';
    };

    function getDeliveryWindowHeaders() {
        const headers = product.deliveryWindows.map(deliveryWindow => (
            <th
                key={'dw-header-' + deliveryWindow.id}
                className={!!deliveryWindow.id ? 'delivery-window-header' : 'delivery-window-header-invalid'}
            >
                <p>{new Date(deliveryWindow.date).toLocaleDateString('en-GB')}</p>
            </th>
        ));

        if (product.deliveryWindows.length < 7) {
            for (let i = product.deliveryWindows.length; i < 7; i++) {
                headers.push(
                    <th
                        key={'invalid-dw-header-' + product.id + '-' + i}
                        className={'delivery-window-header-invalid'}
                    ></th>
                );
            }
        }
        return headers;
    }

    function getEmptyDeliveryWindowQuantities() {
        const quantities = [];

        if (product.deliveryWindows.length < 7) {
            for (let i = product.deliveryWindows.length; i < 7; i++) {
                quantities.push(
                    <td
                        key={'empty-dw-' + product.id + '-' + i}
                        className={'delivery-window-cell-invalid'}
                    ></td>
                );
            }
        }
        return quantities;
    }

    return (
        <>
            <tr
                data-testid={'presell-product-top-' + product.id}
                className={props.highlighted ? 'presell-product-top-highlighted' : 'presell-product-top'}
            >
                <td data-testid={'presell-product-image'}>
                    <FontAwesomeIcon
                        className={reward ? 'presell-promo-icon' : 'presell-promo-icon-hidden'}
                        icon={faGift}
                    />
                    <ProductImage
                        src={product.imageURI}
                        alt={'Brandbank image for ' + product.productDescription}
                    />
                </td>
                <td data-testid={'presell-product-product-code'}>
                    <p>{product.productCode}</p>
                    {!!product.sequenceNumber && (
                        <span className={'presell-sequence-number'}>Seq: {product.sequenceNumber}</span>
                    )}
                </td>
                <td
                    data-testid={'presell-product-product-description'}
                    className={'presell-product-description'}
                >
                    <p>{product.productDescription}</p>
                    {!!product.minQty && (
                        <span className={'presell-quantity-restrictions'}>{'Min: ' + product.minQty}</span>
                    )}
                    {!!product.maxQty && (
                        <span className={'presell-quantity-restrictions'}>{'Max: ' + product.maxQty}</span>
                    )}
                </td>
                <td data-testid={'presell-product-case-size'}>
                    {product.caseSize}x{product.packSize}
                </td>
                <td data-testid={'presell-product-normal-cost'}>{numberToPrice(product.normalCostPrice)}</td>
                <td data-testid={'presell-product-deal-cost'} className={'promo-cost'}>
                    {numberToPrice(product.dealCostPrice)}
                </td>
                <td data-testid={'presell-product-normal-rsp'}>{numberToPrice(product.normalRsp)}</td>
                <td data-testid={'presell-product-deal-rsp'} className={'greenField'}>
                    {numberToPrice(product.dealRsp)}
                </td>
                <td data-testid={'presell-product-margin'} className={'greenField'}>
                    {!!product.margin ? product.margin.toFixed(2) + '%' : ''}
                </td>
            </tr>
            <tr
                data-testid={'presell-product-bottom-' + product.id}
                className={reward ? 'presell-product-bottom-reward' : 'presell-product-bottom'}
            >
                <td className={'delivery-window-table'} colSpan="9" align="center">
                    <div className={'presell-lines'}>
                        <table id={'presell-delivery-window'}>
                            <thead>{getDeliveryWindowHeaders()}</thead>
                            <tbody>
                                <tr>
                                    {props.product.deliveryWindows.map(deliveryWindow =>
                                        !!deliveryWindow.id ? (
                                            <DeliveryWindow
                                                key={'dw-' + deliveryWindow.id}
                                                quantity={deliveryWindow.quantity}
                                                id={deliveryWindow.id}
                                                updateQuantities={props.updateQuantities}
                                                orderingTimeFinished={props.orderingTimeFinished}
                                                minDisabled={minDisabled}
                                                maxDisabled={maxDisabled}
                                            />
                                        ) : (
                                            <td
                                                key={Math.random().toString(36)}
                                                className={'delivery-window-cell-invalid'}
                                            >
                                                Not available to order on this date
                                            </td>
                                        )
                                    )}
                                    {getEmptyDeliveryWindowQuantities()}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </td>
            </tr>
        </>
    );
}
